//  Node imports
import { dispatcher, ingenuity } from "@quest/base-core";
import { IEvent } from "@quest/adapter-interface/dist";
import { MetersController, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-leopard/dist";
import { Model as platformModel, EventConstants as platformEventConstants } from "@quest/platform-murka/dist";
import { EventConstantsLeander } from "@quest/oddsworks-platform";
import { SlotEventConstants } from "@quest/slot-core";
import { GameParserModel } from "../Platform/GameParserModel";

/**
 * MetersControllerGame class handles the meters for the base game
 *  ex. win meter, win tickup etc.
 */
export class MetersControllerGame extends MetersController {
  /**
   * onReturningFreegameUpdateMeter overrided to update the bottom bar win and
   * base win meter after returning from free game.
   * @param evt
   */
  protected onReturningFreegameUpdateMeter(evt: IEvent): void {
    super.onReturningFreegameUpdateMeter(evt);
    dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, {
      value: (
        (ingenuity.parserModel as platformModel).getFreeSpinTotalWin() +
        (ingenuity.parserModel as platformModel).getBaseGameWinAmt()
      ).toString(),
    });
    dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, {
      winAmount:
        (ingenuity.parserModel as platformModel).getFreeSpinTotalWin() +
        (ingenuity.parserModel as platformModel).getBaseGameWinAmt(),
    });
  }
  protected updateBalance() {
    super.updateBalance();
    dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, {
      winAmount: ingenuity.parserModel.getTotalWin().toFixed(2),
    });
  }

  protected onForceStopWinTickUp(evt?: IEvent): void {
    if (this.winValueMeter.getIsTickUpRunning()) {
      (ingenuity.parserModel as GameParserModel).setIsSpinClicked(true);
      if (ingenuity.configData.isAutoplayActive) {
        this.stopWinMeterTickupInAutoPlay();
      } else {
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_STOP_BTN);
        ingenuity.soundManager.stop(this.model.getWinMeterTickUpSound());
        this.winValueMeter.forceStop(this.model.getIsCredits(), false, true, 700, () => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.RESET_WIN_PRESENTATION_ON_SPIN_CLICK);
        });
      }
    } else if (this.model.getIsAutoPlayLeft()) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      this.winValueMeter.stopTickupAndDelay(700, () => {
        if (this.model.getIsAutoPlayLeft()) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.RESET_WIN_PRESENTATION_ON_SPIN_CLICK);
      } else {
        dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
      }
      });
      
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.RESET_WIN_PRESENTATION_ON_SPIN_CLICK);
    }
    if (
      ingenuity.soundManager.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, "soundList") &&
      !ingenuity.configData.isReelSpinMusicPlaying
    ) {
      ingenuity.soundManager.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, "soundList").volume = 1;
    }
  }
}
